import React from "react";

import { Formik, Form, Field, ErrorMessage } from "formik";
import MainExpertForm from "./mainExpertForm";

import PatientImage from "../assets/images/expert-with-patient@2x.png";

export default function MainExpertSignUp({ handleMainSignup, error }) {
  return (
    <div className="create-account-signup">
      <div className="content">
        <div className="row">
          <div className="col-lg-7 col-md-7 pr-md-0 d-none d-sm-block">
            <div className="new-patientes">
              <h2>
                Sign up and connect with
                <br /> new patients
              </h2>
              <img src={PatientImage} alt="Patient Image" />
            </div>
          </div>
          <div className="col-lg-5 col-md-5 pl-md-0">
            <div className="expert-signup">
              <h4>Sign up as an Expert</h4>
              <span>Create an account to reserve your spot.</span>

              <MainExpertForm
                handleMainSignup={handleMainSignup}
                emailError={error}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
